<template>
  <div class="pessoa-cadastro">
    <Dialog class="pessoa-modal" :header="headerDialog" :visible.sync="showCadastroPessoa" :modal="true"
      :closable="false">
      <div id="topo" class="container scrolable-dialog">
        <error-list :erros="erros" />


        <div class="row">
          <div class="col-md-3 mb-2">
            <label for="tipoPessoa">Tipo: *</label>
            <span class="p-fluid">
              <Dropdown id="tipoPessoa" v-model="selectedTipoPessoa" :options="tiposPessoa" optionLabel="name"
                placeholder="Selecione um Tipo de Pessoa" @change="limparDadosPessoa()" />
            </span>
          </div>

          <div class="col-md-3 mb-2">
            <label for="tipoPessoa">{{
              (selectedTipoPessoa.key === "X"
                ? "NIF:"
                : selectedTipoPessoa.key === "F"
                  ? "CPF:"
                  : "CNPJ:") + " *"
            }}</label>
            <span class="p-fluid">



              <div class="p-inputgroup">
                <template v-if="selectedTipoPessoa.key === 'F'">
                  <InputMask @blur="searchContribuintePorCpfCnpj()" v-model="cadastroPessoa.documento" key="F"
                    id="tipoPessoa" mask="999.999.999-99" placeholder="Pesquisar" />
                </template>
                <template v-else>
                  <InputMask @blur="searchContribuintePorCpfCnpj()" v-model="cadastroPessoa.documento" key="J"
                    id="tipoPessoa" mask="99.999.999/9999-99" placeholder="Pesquisar" />
                </template>
                <Button @click="searchContribuintePorCpfCnpj()" type="button" icon="pi pi-search" class="p-button" />
              </div>
            </span>
          </div>


          <div class="col-md-12 mb-2">
            <label for="tipoPessoa">Nome: *</label>
            <span class="p-fluid">
              <InputText v-model="cadastroPessoa.nome" type="text" />
            </span>
          </div>
        </div>

        <div class="row d-flex align-items-end">
          <div class="col-md-3 mb-2">
            <label for="tipoTomador">CEP: *</label>
            <span class="p-fluid">
              <div class="p-inputgroup">
                <InputMask @blur="searchLocalidadePorCep()" v-model="cadastroPessoa.cep" mask="99.999-999"
                  placeholder="Pesquisar" />
                <Button @click="searchLocalidadePorCep()" type="button" icon="pi pi-search" class="p-button"
                  title="Pesquisar CEP" />
              </div>
            </span>
          </div>

          <div class="col-md-3 mb-2">
            <label for="munic">Município: *</label>
            <span class="p-fluid">
              <AutoComplete id="munic" v-model="selectedMunicipio" :dropdown="true" :suggestions="filteredLocalidades"
                @item-select="setLocalidades($event)" @complete="searchLocalidade($event)" field="detail"
                placeholder="Pesquisar" />
            </span>
          </div>

          <div class="col-md-3 mb-2">
            <label for="tipoTomador">Estado:</label>
            <span class="p-fluid">
              <InputText v-model="nomeEstado" type="text" disabled />
            </span>
          </div>

          <div class="col-md-3 mb-2">
            <label for="tipoTomador">País:</label>
            <span class="p-fluid">
              <InputText v-model="nomePais" type="text" disabled />
            </span>
          </div>

          <div class="col-md-3 mb-2">
            <label for="tipoTomador">Bairro: *</label>
            <span class="p-fluid">
              <AutoComplete id="bairr" v-model="selectedBairro" :dropdown="true" :suggestions="filteredBairros"
                @item-select="setBairro($event)" @complete="searchBairro($event)" field="nomeBairro"
                placeholder="Pesquisar" />
            </span>
          </div>

          <div class="col-md-5 mb-2">
            <label for="tipoTomador">Logradouro: *</label>
            <span class="p-fluid">
              <AutoComplete id="logra" v-model="selectedLogradouro" :dropdown="true" :suggestions="filteredLogras"
                @item-select="setLogradouro($event)" @complete="searchLogradouro($event)" placeholder="Pesquisar"
                field="detail">
                <template #item="slotProps">
                  <div class="p-fluid" style="max-width: 50vw">
                    {{ slotProps.item.detail }}
                  </div>
                </template>
              </AutoComplete>
            </span>
          </div>

          <div class="col-md-4 mb-2">
            <label for="tipoTomador">Número: *</label>
            <span class="p-fluid">
              <InputText v-model="cadastroPessoa.numero" type="text" />
            </span>
          </div>

          <div class="col-md-4 mb-2">
            <label for="tipoTomador">Complemento:</label>
            <span class="p-fluid">
              <InputText v-model="cadastroPessoa.complemento" type="text" maxlength="40" />
            </span>
          </div>
        </div>

        <hr />

        <div class="row d-flex align-items-end">
          <div class="col-md-6 mb-2">
            <label for="tipoTomador">E-mail: *</label>
            <span class="p-fluid">
              <InputText v-model="cadastroPessoa.email" type="text" />
            </span>
          </div>

          <div class="col-md-3 mb-2">
            <label for="tipoTomador">Telefone:</label>
            <span class="p-fluid">
              <InputMask v-model="cadastroPessoa.contato" mask="(99) 9999-9999" />
            </span>
          </div>

          <div class="col-md-3 mb-2">
            <label for="tipoTomador">Celular:</label>
            <span class="p-fluid">
              <InputMask v-model="cadastroPessoa.contatocelular" mask="(99) 99999-999?9" />
            </span>
          </div>
        </div>

        <hr />
      </div>

      <hr />

      <div class="container">
        <div class="row">
          <div>
            <Button @click="salvar()" href="#topo" type="button" label="Gravar"
              class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading" />
          </div>

          <div>
            <Button @click="showCadastroPessoa = false" type="button" label="Fechar"
              class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
          </div>
        </div>
      </div>
    </Dialog>

    <Dialog header="Seleção Endereço" :visible.sync="showSelectLogra" :modal="true" :closable="false">
      <div class="container scrolable-dialog selecao-contribuinte">
        <div class="row">
          <DataTable :value="logradouroList" :paginator="true" :rows="5" style="min-width: 100%">
            <Column field="detail" header="Endereço:"></Column>
            <Column headerStyle="width: 58px" bodyStyle="text-align: center">
              <template #body="objeto">
                <Button type="button" icon="pi pi-check" title="Selecionar"
                  @click="preencherDadosLogradouro(objeto.data)"></Button>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>

      <hr />

      <div class="container">
        <div class="row">
          <div>
            <Button @click="showSelectLogra = false" type="button" label="Fechar"
              class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import SolicitacaoCadastroService from "../services/tributario/solicitacao.cadastro.service";
import PessoaService from "../services/acesso/pessoa.service";
import PaisService from "../services/acesso/pais.service";
import PessoaCadastro from "../models/acesso/PessoaCadastro";
import Util from "../Utils/util";

export default {
  name: "PessoaCadastro",

  props: {
    tipoEmissao: String,
  },

  data() {
    return {
      idCliente: null,
      loading: false,
      erros: [],
      showCadastroPessoa: false,
      cadastroPessoa: new PessoaCadastro(),
      tiposPessoa: [
        { name: "Pessoa Física", key: "F" },
        { name: "Pessoa Jurídica", key: "J" },
        { name: "Entidade", key: "E" }
      ],
      selectedTipoPessoa: null,
      filteredLocalidades: null,
      filteredPaises: null,
      selectedMunicipio: null,

      selectedPais: null,
      selectedBairro: null,
      filteredBairros: null,
      selectedLogradouro: null,
      filteredLogras: null,
      utilizaPesquisaSerpro: false,
      logradouroList: [],
      showSelectLogra: false,
    };
  },

  created() {
    this.$root.$on("pessoaCadastro:novo", idCliente => {
      this.idCliente = idCliente;
      this.novoPessoa();
    });
    this.selectedTipoPessoa = this.tiposPessoa[0];
    this.limparDadosPessoa();
  },

  methods: {
    // Deverá ser chamado para validação do formulário, antes de salvar
    onSubmit() {
      this.$validate().then((success) => {
        if (success) {
          this.salvar();
        }
      });
    },

    salvar() {
      if (!this.cadastroPessoa.email || !Util.validarEmail(this.cadastroPessoa.email)) {
        this.$root.$emit(
          "alert:warn",
          "É necessário informar um endereço de E-mail válido!"
        );
      } else if (!this.selectedBairro || typeof this.selectedBairro.id === "undefined") {
        this.$root.$emit(
          "alert:warn",
          "Bairro é um campo de seleção, digite a informação e selecione o registro apresentado na pesquisa!"
        );
      } else if (!this.selectedLogradouro || typeof this.selectedLogradouro.id === "undefined") {
        this.$root.$emit(
          "alert:warn",
          "Logradouro é um campo de seleção, digite a informação e selecione o registro apresentado na pesquisa!"
        );
      } else {
        this.processando(true);
        this.cadastroPessoa.idCliente = this.idCliente;
        this.cadastroPessoa.tipo = this.selectedTipoPessoa.key;

        this.cadastroPessoa.idCepLocalidade = this.selectedMunicipio
          ? this.selectedMunicipio.id
          : "";
        if (this.selectedBairro) {
          this.cadastroPessoa.idBairro = this.selectedBairro.id;
          this.cadastroPessoa.bairro = this.selectedBairro.nomeBairro;
        } else {
          this.cadastroPessoa.idBairro = null;
        }

        if (this.selectedLogradouro && this.selectedLogradouro.id) {
          this.cadastroPessoa.idLogradouro = this.selectedLogradouro.id;
          this.cadastroPessoa.logradouro =
            this.selectedLogradouro.nomeLogradouro;
          if (this.selectedLogradouro.idCepTipoLogra && this.selectedLogradouro.idCepTipoLogra.nomeTipoLogra) {
            this.cadastroPessoa.tipoLogra =
              this.selectedLogradouro.idCepTipoLogra.nomeTipoLogra;
          }
        } else {
          this.cadastroPessoa.idLogradouro = null;
        }
        if (this.cadastroPessoa.tipoLogra === '') {
          this.cadastroPessoa.tipoLogra = '.';
        }

        this.cadastroPessoa.cidade = this.selectedMunicipio
          ? this.selectedMunicipio.nomeLocalidade
          : "";

        this.cadastroPessoa.estado =
          this.selectedMunicipio && this.selectedMunicipio.estado
            ? this.selectedMunicipio.estado.nomeEstado
            : "";

        this.erros = [];

        SolicitacaoCadastroService.salvarPessoa(this.cadastroPessoa)
          .then(
            (data) => {
              console.log(data);
              this.limparDadosPessoa();
              this.showCadastroPessoa = false;

              this.$parent.selectedPessoa = data.data;

              this.$root.$emit("alert:success", "O Sócio foi salvo com sucesso!");
            },
            (error) => {
              const erros = error.response.data;
              this.erros.push(...erros);

              if (!this.erros.length) {
                this.$root.$emit(
                  "alert:error",
                  "Houve um problema ao salvar o Sócio!"
                );
              }
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
    },

    searchLocalidade(event) {
      setTimeout(async () => {
        this.filteredLocalidades =
          await SolicitacaoCadastroService.findAllByFiltro(event.query);
      }, 250);
    },

    setBairro(event) {
      this.processando(true);
      this.selectedBairro = event.value;
      this.processando(false);
    },

    searchBairro(event) {
      setTimeout(async () => {
        this.filteredBairros =
          await SolicitacaoCadastroService.findAllBairroByFiltro(
            this.idCliente,
            event.query
          );
      }, 250);
    },

    setLogradouro(event) {
      this.processando(true);
      this.selectedLogradouro = event.value;
      this.processando(false);
    },

    searchLogradouro(event) {
      setTimeout(async () => {
        this.filteredLogras =
          await SolicitacaoCadastroService.findAllLogradouroByFiltro(
            this.idCliente,
            event.query
          );
      }, 250);
    },

    searchLocalidadePorCep() {
      if (this.cadastroPessoa.cep !== "") {
        this.processando(true);
        let cep = this.cadastroPessoa.cep;
        cep = cep.replace(".", "");
        cep = cep.replace("-", "");
        SolicitacaoCadastroService.findAllLograByCep(cep)
          .then(
            (response) => {
              if (response.data.length && response.data.length > 1) {
                this.logradouroList = response.data;
                this.showSelectLogra = true;
              } else if (response.data.length > 0) {
                this.selectedCepLogra = response.data[0];
                this.preencherDadosLogradouro(this.selectedCepLogra);
              }
            },
            (error) => {
              let errorMessage = "Houve um problema ao listar Logradouros!";
              if (error.response) {
                errorMessage = error.response.data;
              }
              this.$toast.add({
                severity: "error",
                summary: errorMessage,
              });
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
    },


    preencherDadosLogradouro(logradouro) {
      this.processando(true);
      this.cadastroPessoa.cep = logradouro.cepLogradouro;
      this.cadastroPessoa.bairro = logradouro.nomeBairro;
      this.cadastroPessoa.tipoLogra = logradouro.nomeTipoLogra;
      this.cadastroPessoa.logradouro = logradouro.nomeLogradouro;
      SolicitacaoCadastroService.findAllById(logradouro.idCepLocalidade)
        .then((response) => {
          this.selectedMunicipio = response.data;
        })
        .then(() => {
          this.processando(false);
          this.showSelectLogra = false;
        });
    },

    searchPais(event) {
      setTimeout(async () => {
        this.filteredPaises = await PaisService.findAllByFiltro(event.query);
      }, 250);
    },

    searchContribuintePorCpfCnpj() {
      const documento = this.cadastroPessoa.documento;
      this.utilizaPesquisaSerpro = false;
      if (documento !== "" && this.validarDocumento()) {
        this.processando(true);

        PessoaService.findAllByClienteFiltro(this.idCliente, documento, 'C')
          .then((data) => {
            console.log(data);

            if (data.length) {
              this.$root.$emit("alert:warn", "ja existe um registro de Pessoa para este documento, não é possível realizar o cadastro!");
              this.limparDadosPessoa();
            }
          },
            (error) => {
              if (error.response.data) {
                this.cadastroPessoa.documento = null;
                this.$root.$emit("alert:warn", error.response.data);
              } else {
                this.$root.$emit("alert:warn", "não foi possível consultar o cadastro!");
              }
            })
          .then(() => {
            this.processando(false);
          });
      } else {
        this.limparDadosPessoa();
      }
    },

    setLocalidades(event) {
      this.selectedMunicipio = event.value;
    },

    novoPessoa() {
      this.limparDadosPessoa();
      this.selectedTipoPessoa = this.tiposPessoa[0];
      this.showCadastroPessoa = true;
    },

    limparDadosPessoa() {
      this.cadastroPessoa = new PessoaCadastro();
      this.selectedMunicipio = null;
      this.selectedBairro = null;
      this.selectedLogradouro = null;
      this.selectedPais = null;
      this.erros = [];
    },

    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },

    validarDocumento() {
      var validar = false;
      validar = Util.validarCPFCNPJ(this.cadastroPessoa.documento);

      if (!validar) {
        console.log(validar);
        let doc = this.cadastroPessoa.documento;
        this.cadastroPessoa.documento = '';
        this.$root.$emit("alert:error", "CPF/CNPJ " + doc + " inválido!");
      }
      return validar;
    },
  },

  computed: {



    nomeEstado() {
      return this.selectedMunicipio && this.selectedMunicipio.estado
        ? this.selectedMunicipio.estado.detail
        : "";
    },

    nomePais() {
      return this.selectedMunicipio &&
        this.selectedMunicipio.estado &&
        this.selectedMunicipio.estado.pais
        ? this.selectedMunicipio.estado.pais.detail
        : "";
    },

    headerDialog() {
      return (
        "Cadastro de  Sócio"
      );
    },
  },
};
</script>

<style scoped>
.scrolable-dialog {
  padding-right: 25px;
  width: 90vw;
  max-height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
  text-align: left;
}

.selecao-contribuinte {
  width: 80vw;
}

.mensagem-edicao {
  color: red;
  font-weight: bold;
}
</style>